export const purchasesEsLocale = {
  'purchases.purchaseMade': 'Compras realizadas',
  'purchases.years': 'Año',
  'purchases.purchaseDate': 'Fecha de compra',
  'purchases.eventDate': 'Fecha de evento',
  'purchases.numberOfTickets': 'Tickets comprados',
  'purchases.totalCost': 'Total',
  'purchases.details': 'Detalles',
  'purchases.event': 'Evento',
  'purchases.ticket': 'Ticket',
  'purchases.calendar': 'Fecha de evento: ',
  'purchases.view': 'Ver Tickets',
  'purchases.past': 'Pasadas',
  'purchases.comming': 'Próximas',

  'purchases.purchaseId': 'ID de compra',
  'purchases.purchaseIdPlaceholder': 'Buscar por ID de compra',
  'purchases.allYears': 'Todos los años',
  'purchases.year': 'Año',
} as const;

export const purchasesEnLocale = {
  'purchases.purchaseMade': 'Purchases made',
  'purchases.years': 'Year',
  'purchases.purchaseDate': 'Purchase date',
  'purchases.eventDate': 'Event date',
  'purchases.numberOfTickets': 'Number of tickets',
  'purchases.totalCost': 'Total cost',
  'purchases.details': 'Details',
  'purchases.event': 'Event',
  'purchases.ticket': 'Ticket',
  'purchases.calendar': 'Event date: ',
  'purchases.view': 'View Tickets',
  'purchases.past': 'Past',
  'purchases.comming': 'Upcoming',

  'purchases.purchaseId': 'Purchase ID',
  'purchases.purchaseIdPlaceholder': 'Search by purchase ID',
  'purchases.allYears': 'All years',
  'purchases.year': 'Year',
} as const;
